<template>
	<form :key="'PERSONAL_INFO'" :class="{ 'px-100-md': thirdPartyAuthStore.isSignupEnabled }" @submit.prevent>
		<h1 class="heading-4" data-test="email-title">What is your email address?</h1>
		<p class="text-color-content-secondary mt-50 mb-150">
			Tell us a bit about yourself -- we'll create your account and suggest the strategy that best fits
			your&nbsp;goals.
		</p>
		<LeadCaptureComponent class="mt-25" :form-config="leadCaptureFormConfig" />
	</form>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import LeadCaptureComponent from '@components/lead-capture/lead-capture-form.vue';
import MobileRedirectModal from '@components/modals/mobile-redirect-modal.vue';
import { useAppStore } from '@stores/app';
import { useSignupStore } from '@stores/signup';
import { useThirdPartyAuthStore } from '@stores/third-party-auth';
import { isMobileOS } from '@utils/client';
import { EmailCaptureFields, LeadCaptureFormConfig } from 'types/layout/lead';

const signupStore = useSignupStore();

const router = useRouter();

const appStore = useAppStore();
const thirdPartyAuthStore = useThirdPartyAuthStore();

const leadCaptureFormConfig = computed(
	(): LeadCaptureFormConfig => ({
		buttonText: 'Continue',
		forceShowInput: true,
		fullWidth: true,
		buttonClass: 'button-primary lead-capture__button-primary width-100',
		placeholder: 'Email address',
		redirectCallback: redirectAfterSubmit,
		signupFlowType: 'STANDARD'
	})
);

const isMobileDevice = computed((): boolean => {
	return isMobileOS();
});

async function redirectAfterSubmit(leadResponseData: EmailCaptureFields): Promise<void> {
	signupStore.emailCaptureFields = leadResponseData;
	const queryData: Record<string, string> = {};

	if (leadResponseData.newLead) {
		queryData.new_lead = String(leadResponseData.newLead);
	}
	if (leadResponseData.mixpanelId) {
		queryData.distinct_id = String(leadResponseData.mixpanelId);
	}

	if (isMobileDevice.value) {
		appStore.updateCurrentModal({
			modal: MobileRedirectModal,
			props: {
				continueLink: {
					text: 'No thanks, continue on mobile browser',
					router: 'checkout-password',
					query: queryData
				}
			}
		});
	} else {
		await router.push({
			name: 'checkout-password',
			query: queryData
		});
	}
}
</script>
